import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DeviceLogService } from '../services/device-log.service';

const URL_LENGTH = 500;

// Failed HTTP requests in the device log: method, URL, status and how long they took. The
// outermost interceptor, so it sees what the caller gets (after TokenInterceptor's retries).
@Injectable()
export class DeviceLogInterceptor implements HttpInterceptor {
  constructor(private _deviceLog: DeviceLogService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startedAt = Date.now();
    return next.handle(request).pipe(
      tap({
        error: (error) => {
          const status = typeof error?.status === 'number' ? error.status : undefined;
          const url = request.urlWithParams.length > URL_LENGTH ? `${request.urlWithParams.slice(0, URL_LENGTH)}…` : request.urlWithParams;
          // 4xx is the server refusing this request; no answer (0), 5xx or a timeout is a failure.
          const level = status !== undefined && status >= 400 && status < 500 ? 'warn' : 'error';
          this._deviceLog.add(level, 'http', [`${request.method} ${url} → ${status ?? error?.name ?? 'error'}`], {
            status,
            statusText: error?.statusText,
            durationMs: Date.now() - startedAt,
            error: error?.error ?? error?.message ?? error,
          });
        },
      }),
    );
  }
}
